<script lang="typescript">
    export let text: string = "H2/Roboto/Light/60px";
    export let color = "var(--color-level-6)";
</script>

<h2 style="color: {color};" class="headline2">{text}</h2>

<style>
    .headline2 {

        /* Headline 2 */
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 60px;
        line-height: 72px;
        /* identical to box height, or 120% */
        letter-spacing: -0.5px;

        color: rgba(255, 255, 255, 0.87);
    }

</style>
